/* eslint-disable */
/**
 * OnlineBedStore — Hulk Product Options swatch collapse.
 *
 * Hulk Product Options renders fabric/colour swatches as direct children
 * of `.hulkapps_option_value` inside `.hulkapps_option.swatch_render`.
 * This script collapses lists with > 5 swatches behind a "+ N more" toggle
 * so the Add to Cart button stays above the fold on mobile.
 *
 * Hulk injects its DOM asynchronously after page load — we use a
 * MutationObserver plus a short retry loop to catch late renders
 * (including switches between products / quick-add modals).
 */
(function () {
  'use strict';

  var SHOW_LIMIT = 5;
  var INIT_FLAG = 'data-collapse-initialised';

  function applyCollapse(option) {
    if (option.getAttribute(INIT_FLAG)) return;

    var valueContainer = option.querySelector(':scope > .hulkapps_option_value');
    if (!valueContainer) return;

    var labels = valueContainer.querySelectorAll(':scope > label.hulkapps_swatch_option');
    if (labels.length <= SHOW_LIMIT) return;

    option.setAttribute(INIT_FLAG, '1');
    option.classList.add('hulkapps_option--collapsible', 'hulkapps_option--collapsed');

    // If a swatch beyond the limit is already selected, start expanded so
    // the user can see their selection.
    var hiddenSelected = false;
    for (var i = SHOW_LIMIT; i < labels.length; i++) {
      var l = labels[i];
      var input = l.querySelector('input[type="radio"], input[type="checkbox"]');
      if (
        l.classList.contains('hulkapps_swatch_active') ||
        l.classList.contains('selected') ||
        l.classList.contains('active') ||
        (input && input.checked)
      ) {
        hiddenSelected = true;
        break;
      }
    }
    if (hiddenSelected) option.classList.remove('hulkapps_option--collapsed');

    var moreCount = labels.length - SHOW_LIMIT;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hulkapps-show-more';
    btn.dataset.moreLabel = '+' + moreCount;
    btn.dataset.fewerLabel = 'Less';
    var collapsed = option.classList.contains('hulkapps_option--collapsed');
    btn.innerHTML =
      '<span class="hulkapps-show-more__discs" aria-hidden="true">' +
        '<span class="hulkapps-show-more__disc hulkapps-show-more__disc--1"></span>' +
        '<span class="hulkapps-show-more__disc hulkapps-show-more__disc--2"></span>' +
        '<span class="hulkapps-show-more__disc hulkapps-show-more__disc--3"></span>' +
      '</span>' +
      '<span class="hulkapps-show-more__count"></span>';
    var countEl = btn.querySelector('.hulkapps-show-more__count');
    countEl.textContent = collapsed ? btn.dataset.moreLabel : btn.dataset.fewerLabel;
    btn.setAttribute('aria-expanded', String(!collapsed));

    btn.addEventListener('click', function (evt) {
      evt.preventDefault();
      var nowCollapsed = option.classList.toggle('hulkapps_option--collapsed');
      countEl.textContent = nowCollapsed ? btn.dataset.moreLabel : btn.dataset.fewerLabel;
      btn.setAttribute('aria-expanded', String(!nowCollapsed));
    });

    valueContainer.appendChild(btn);
  }

  function scan() {
    document
      .querySelectorAll('.hulkapps_option.swatch_render')
      .forEach(applyCollapse);
  }

  // Watch for Hulk's async injection (and re-injection in quick-add modals etc.).
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.classList && node.classList.contains('hulkapps_option')) ||
          (node.querySelector &&
            node.querySelector('.hulkapps_option.swatch_render'))
        ) {
          scan();
          return;
        }
      }
    }
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    scan();
    // Hulk can take a few seconds to render — retry a handful of times.
    var retries = 0;
    var interval = setInterval(function () {
      scan();
      if (++retries >= 12) clearInterval(interval);
    }, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
